import { IsBoolean } from "class-validator";
import { Expose } from "class-transformer";

export default class OrderExportSetting {
  @IsBoolean()
  @Expose()
  exportOrderAutomaticAfterGenerateInvoice!: boolean;

  @IsBoolean()
  @Expose()
  exportOrder!: boolean;

  @IsBoolean()
  @Expose()
  exportCostDocument!: boolean;

  @IsBoolean()
  @Expose()
  exportCostDocumentOther!: boolean;
}
